module.exports = __webpack_public_path__ + "static/media/step1-active.c732d4a7.svg";